import { ready } from "@/lib/ready";
import { loadJq } from "@/lib/loadJq";
import { loadJs } from "@/lib/loadJs";
import { onceOptions } from "@/lib/onceOptions";
import { on } from "@/lib/dom/on";
import { showElement } from "@/lib/dom/showElement";
import { hideElement } from "@/lib/dom/hideElement";
import { toggleClass } from "@/lib/dom/toggleClass";
import { hasClass } from "@/lib/dom/hasClass";
import { removeNode } from "@/lib/dom/removeNode";
import { addStyle } from "@/lib/dom/addStyle";
import { onMatchMedia } from "@/lib/browser"
import { removeClass } from "@/lib/dom/removeClass";
import { addClass } from "@/lib/dom/addClass";
import { getIndex } from "@/lib/dom/getIndex";
import { getPosition } from "@/lib/dom/getPosition";
import { setWidth } from "@/lib/dom/setWidth";
import { loadCarousel, type CarouselOptions } from "@/share/carousel"

import "@/share/review"
import './index.less'
import "@/share/global"
import "@/share/header"
import "@/share/footer"
import "@/share/drawer"
import "@/share/product-show/filter"
import "@/share/product-show/sortby"


import "./global"
import "./mobile"
import "./onsale"
// import "./copy-link"
import { ThirdPartySubscribeOptIn } from "./subscribe"
import { lazyLoad } from "@/lib/lazyLoad";

ready(() => {
  const carouselCateBanner = document.querySelector<HTMLElement>('#carouselCateBanner');
  if (carouselCateBanner && carouselCateBanner.querySelectorAll("li").length > 1) {
    loadCarousel(carouselCateBanner, {
      autoStart: true,
      interval: 5000,
      perPage: 1
    })
  }
  const jcarouselCategory = document.querySelector<HTMLElement>('#carouselcate');
  if (jcarouselCategory) {
    loadCarousel(jcarouselCategory, {
      autoStart: true,
    })
  }
  const jcarouselLp = document.querySelector<HTMLElement>('#jcarousel-lp');
  if (jcarouselLp) {
    loadCarousel(jcarouselLp, {
      autoStart: true,
      autoScrollNum: 1,
      responsive: {
        0: 2,
        450: 3,
        600: 4,
        750: 5,
        1000: 7
      }
    })
  }
  const jcarouselRecently = document.querySelector<HTMLElement>('#jcarousel-recently');
  if (jcarouselRecently) {
    loadCarousel(jcarouselRecently, {
      responsive: {
        0: 2,
        500: 3,
        740: 4,
        980: 5
      }
    })
  }


  const carouselcate = document.querySelector<HTMLElement>('#carouselcate');
  if (carouselcate) {
    loadCarousel(carouselcate, {
      autoStart: true,
      perPage: 1,
    })
  }
  const carouselBottom = document.querySelector<HTMLElement>('#carouselBottom');
  if (carouselBottom) {
    loadCarousel(carouselBottom, {
      autoStart: true,
      perPage: 1,
    })
  }
})


ready(() => {
  // loadJs('https://www.youtube.com/iframe_api')
  const videoEls = document.querySelectorAll('.video-icon') as NodeListOf<HTMLElement>
  videoEls.forEach((el: HTMLElement) => {
    on(el, 'click', () => {
      const videoUrl = el.dataset['videoUrl']
      const videoThumb = el.dataset['videoThumb']
      if (videoUrl) {
        // loading.show();

        import('@/share/play-video').then(f => {
          const { playVideo, closeVideo } = f.usePlayVideo(800, 495);
          playVideo({
            videoUrl: videoUrl,
            thumbnail: videoThumb,
            reloadVideo: true,
          });
        })
      }
    })
  })
})


ready(() => {
  on(".onsale-content", "mouseover", (e: MouseEvent) => {
    const This = e.currentTarget as HTMLElement;
    (This.querySelectorAll('.moreSmall') as NodeListOf<HTMLElement>).forEach((item, index) => {
      const imgName = item.dataset['path']
      // var imgName = $(this).data('path');
      // var hdImgPreUrl = This.find('.hdImgPreUrl').html();
      const hdImgPreUrl = This.querySelector('.hdImgPreUrl')!.innerHTML;
      const name = This.querySelector('.zoom-tiny-image')?.getAttribute('title') ?? '';
      // $(this).html('<input type="hidden" value="' + hdImgPreUrl + '/0220/' + imgName + '"><img class="zoom-tiny-image" src="' + hdImgPreUrl + '/0080/' + imgName + '" alt="' + name + '" title="' + name + '" />');

      item.insertAdjacentHTML('afterbegin', `<input type="hidden" value="${hdImgPreUrl}/0220/${imgName}"><img class="zoom-tiny-image" src="${hdImgPreUrl}/0080/${imgName}" alt="${name}" title="${name}" />`)
      removeClass(item, 'moreSmall');
    });
  }, onceOptions);
})
ready(() => {

  const itemSpan = getComputedStyle(document.documentElement).getPropertyValue('--item-span');
  const colLength = parseInt(itemSpan);
  const smallimgonewidth = 36;
  let smallimgshowCount = 5;


  const set_thumb_bar_light = (elem: HTMLElement, left: boolean, right: boolean) => {

    const obj_bar = elem.parentNode!.parentNode!;
    const img_moveleft = obj_bar.querySelector('.img_moveleft') as HTMLElement;
    const img_moveright = obj_bar.querySelector('.img_moveright') as HTMLElement;
    if (img_moveleft) {
      if (left) {
        removeClass(img_moveleft, 'categorypage01');
        addClass(img_moveleft, 'categorypage03');
      } else {
        removeClass(img_moveleft, 'categorypage03');
        addClass(img_moveleft, 'categorypage01');

      }
    }
    if (img_moveright) {
      if (right) {
        removeClass(img_moveright, 'categorypageright03');
        addClass(img_moveright, 'categorypageright01');
      } else {
        removeClass(img_moveright, 'categorypageright01');
        addClass(img_moveright, 'categorypageright03');
      }
    }
  }

  const clickElement = (elem: HTMLElement) => {
    const aTarget = elem.closest('a') as HTMLElement;

    const parentNode = aTarget.parentNode as HTMLElement;
    const input = parentNode.querySelector('input') as HTMLInputElement;
    const onsaleContent = parentNode.closest('.onsale-content') as HTMLInputElement;

    const pid = input.value;

    const objImg = onsaleContent.querySelector("#imgBig" + pid)!.querySelector("img")!;
    const big_img_src = (aTarget.querySelector("input") as HTMLInputElement)?.getAttribute("value")!;
    removeClass(parentNode!.querySelectorAll('img'), 'selected')
    addClass(aTarget.querySelector("img")!, 'selected')
    if (big_img_src.lastIndexOf('/grey.gif') == -1) {
      objImg.setAttribute("src", big_img_src);
    }

    const index = getIndex(aTarget);
    if (index === 0) {
      set_thumb_bar_light(parentNode, false, true);
    } else if (index == parentNode.querySelectorAll("img").length - 1) {
      set_thumb_bar_light(parentNode, true, false);
    } else {
      set_thumb_bar_light(parentNode, true, true);
    }

  }
  const InitSmallImgEvent = (handle?: HTMLElement) => {
    let handle1 = document.body;
    if (handle != undefined)
      handle1 = handle;

    on(".div_roll a", 'click', (e: MouseEvent) => {
      clickElement(e.target as HTMLElement)
    });
    on(".div_roll a", 'mouseover', (e: MouseEvent) => {
      clickElement(e.target as HTMLElement)
    });

    const updateGallery = (objRoll: HTMLElement, currentIndex: number) => {
      const images = objRoll.querySelectorAll('img');
      images.forEach((img, index) => {
        img.classList.remove('selected');
        if (index === currentIndex) {
          img.classList.add('selected');
          clickElement(img);
        }
      });

      set_thumb_bar_light(objRoll.parentElement!, currentIndex > 0, currentIndex < images.length - 1);

      // 计算是否需要翻页
      const currentPage = Math.floor(currentIndex / smallimgshowCount);
      const offset = currentPage * smallimgonewidth * smallimgshowCount; // 包括margin
      objRoll.style.transform = `translateX(-${offset}px)`;
    }

    on(handle1.querySelectorAll('.img_moveleft'), 'click', (e: MouseEvent) => {
      const currentTarget = e.currentTarget as HTMLElement
      //先查找到tr
      const tr = currentTarget.parentNode!.parentNode!

      //找到滚动
      const objRoll = tr.querySelector(".div_roll") as HTMLElement;

      //查找当前选中图片位置
      const obj_selected = objRoll.querySelector(".selected");
      let currentIndex = 0;
      if (!obj_selected) {
        currentIndex = 0;
      } else {
        currentIndex = getIndex(obj_selected, objRoll.querySelectorAll('img'))
      }
      if (currentIndex > 0) {
        currentIndex--;
        updateGallery(objRoll, currentIndex);
      }
    });
    on(handle1.querySelectorAll('.img_moveright'), 'click', (e: MouseEvent) => {
      const currentTarget = e.currentTarget as HTMLElement
      //先查找到tr
      const tr = currentTarget.parentNode!.parentNode!

      //找到滚动
      const objRoll = tr.querySelector(".div_roll") as HTMLElement;

      //查找当前选中图片位置
      const obj_selected = objRoll.querySelector(".selected");
      let currentIndex = 0;
      if (!obj_selected) {
        currentIndex = 0;
      } else {
        currentIndex = getIndex(obj_selected, objRoll.querySelectorAll('img'))
      }
      if (currentIndex < objRoll.querySelectorAll("a").length - 1) {

        currentIndex++;
        updateGallery(objRoll, currentIndex);
      }
    });

    handle1.querySelectorAll(".div_roll").forEach((item, index) => {
      // $(this).find("img").removeClass('selected');
      removeClass(item.querySelectorAll('img'), 'selected')


      const indexImage = parseInt(item.querySelector('.hdImageIndex')!.innerHTML);
      //$(this).find("a").eq(indexImage).click();
      // $($(this).find("img")[0]).addClass('selected');
      addClass(item.querySelectorAll('img')[0], 'selected')

      const length = item.querySelectorAll(".cloud-zoom-gallery").length;
      if (indexImage > smallimgshowCount - 1) {
        // $(this).css('left', -indexImage * smallimgonewidth + 'px');
        // $(this).find('.lazy12').trigger("sporty");
      }
      if (length > smallimgshowCount) {
        const obj_bar = item.parentNode!.parentNode!.parentNode!;
        addStyle(obj_bar.querySelectorAll('.img_moveleft'), 'display', 'inline-block')
        addStyle(obj_bar.querySelectorAll('.img_moveright'), 'display', 'inline-block')
      }
    });
  }
  const CheckSmallImgChange = (total: number) => {
    if (smallimgshowCount != total) {//需要改变默认小图数量
      smallimgshowCount = total;
      setWidth('.smallImgBody', smallimgonewidth * smallimgshowCount + 8 + 'px')
      // $('.smallImgBody').css('width', smallimgonewidth * smallimgshowCount + 8 + 'px');
      InitSmallImgEvent();
    }
  }
  if (onMatchMedia(1200)) {
    CheckSmallImgChange(5)
  }
  else if (onMatchMedia(1056)) {
    CheckSmallImgChange(4)
  }
  else if (onMatchMedia(992)) {
    CheckSmallImgChange(3)
  }
  else if (onMatchMedia(969)) {
    CheckSmallImgChange(5)
  }
  else if (onMatchMedia(861)) {
    //右侧一个商品Block占用宽度最大为241, 3*241+246(左侧)=969，  剪掉一个小图是36， 共3个
    //969-36*3=861
    CheckSmallImgChange(4)
  }
  else if (onMatchMedia(768)) {
    CheckSmallImgChange(3)
  }
  else if (onMatchMedia(482)) {
    CheckSmallImgChange(5)
  }
  else if (onMatchMedia(410)) {
    CheckSmallImgChange(4)
  } else {
    CheckSmallImgChange(5)
  }

  InitSmallImgEvent();
})



// @ts-ignore
Array.prototype.in_array = function (e) {
  for (let i = 0; i < this.length; i++) {
    if (this[i] == e)
      return true;
  }
  return false;
};

let body_media_width: number = 0;
let scrollbar_w: number = 0;
let sm_page_width: number = 0
let body_page_width: number = 0

function scrollbar_width () {
  const body_page_height = document.body.clientHeight;
  const windowHeight = window.innerHeight;
  if (body_page_height > windowHeight) {
    const scrollDiv = document.createElement("div");
    scrollDiv.className = "scrollbar-measure";
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  }
  return 0;
}

function SetMediaWidth () {
  body_page_width = document.body.clientWidth;
  // body_page_width = $('body').width();
  body_media_width = body_page_width + scrollbar_w;
}


ready(() => {
  scrollbar_w = scrollbar_width();
  sm_page_width = 992 - scrollbar_w;
  SetMediaWidth()
  Object.assign(window, {
    sm_page_width,
    body_media_width,
    body_page_width
  })
})

ready(() => {

  //判断为自定义页面，大分类页面显示小分类列表。
  const isCustomPage = !!document.querySelector('.subcategories-section');
  if (isCustomPage) {
    return;
  }

  import('@/share/wish-list').then(r => {
    r.wishList();
  })

  // import('@/share/copy-link').then(r => {
  //   r.init();
  // })

  const GetSubUrl = () => {
    const hostname = window.location.hostname;
    const href = window.location.href;
    const path = href.substring(href.lastIndexOf(hostname) + hostname.length);
    return path;
  }
  const formatDate = (num: number) => {
    return num.toString()
  }


  const BindDatePick = () => {
    const startDate = new Date();
    $('.panel-r-btn-date').datepick({
      minDate: startDate,
      monthsToShow: 2,
      onSelect: function (dateText: any, inst: any) {
        if (dateText != '') {
          const date = new Date(dateText);
          $('.panel-r-btn-date').val(formatDate(date.getMonth() + 1) + '/' + formatDate(date.getDate()));
          $('.panel-r-btn-date').next().val(formatDate(date.getMonth() + 1) + '/' + formatDate(date.getDate()) + '/' + formatDate(date.getFullYear()));
        }
        else {
          $('.panel-r-btn-date').next().val('');
        }

        (window as any).PromoWizardObj.RequestDate = $('.panel-r-btn-date').next().val();
      }
    });
  }

  loadJq(() => {
    let urlParma = window.siteConfig.webResourcePath + "jscripts/2017/PromoWizardPageStyle2.js";

    //@ts-ignore
    if (typeof window.IsNeedLoadMoreFunction != 'undefined') {
      urlParma = window.siteConfig.webResourcePath + "jscripts/2017/PromoWizardLoadMoreStyle.js";
    }

    //@ts-ignore
    if (typeof (window as any).IsNoNeedPW == 'undefined') {
      const date1 = new Date();
      loadJs(window.siteConfig.webResourcePath + 'jscripts/jquery.animate-colors-min.js').then(() => {
        loadJs(urlParma + '?v=' + date1.getFullYear() + date1.getMonth() + date1.getDate()).then(() => {

          if (typeof (window as any).IsNeedLoadMoreFunction != 'undefined') {
            ready(() => {

              document.body.insertAdjacentHTML('beforeend', '<div id="preloadloadingmore"><img src="https://img66.anypromo.com/frontimg/2018/icon/load_more.gif"></div>');
              removeNode('#preloadloadingmore');

              if (history.state != null && typeof ((window as any).RecoverHistory) == 'function') {
                (window as any).RecoverHistory();
                history.pushState(null, '', GetSubUrl());
              }
            })
          }
          let currentGetdatepick: any | null = null;
          $(document).on('mouseover', '.wishlist-panel', function () {
            if (!currentGetdatepick && typeof ($ as any).datepick == "undefined") {
              currentGetdatepick = $.ajax({
                url: window.siteConfig.webResourcePath + 'jscripts/2018/jquery.plugin.min.js',
                dataType: "script",
                cache: true,
                success: function () {
                  $.ajax({
                    url: window.siteConfig.webResourcePath + 'jscripts/2018/jquery.datepick.min.js',
                    dataType: "script",
                    cache: true,
                    success: function () {
                      BindDatePick();
                    }
                  });
                }
              });
            }
          });
        })
      })
      // const url = siteConfig.webResourcePath + 'jscripts/2017/WishList.js?v=' + date1.getFullYear() + date1.getMonth() + date1.getDate();
      // loadJs(url)
    }
  })
})

ready(() => {
  // @ts-ignore
  import("@/share/couponbar")

  const tooltipElements = document.querySelectorAll<HTMLElement>('.a_glossary');
  import('@/lib/tooltip').then(f => {
    f.aptip(tooltipElements);
  })
})

ready(() => {
  /*
  页面样式动态加载方案
   */
  const { pageStyle, isOriginal, parentCategoryID } = (window as any)
  // 0 : Original
  // 1: SubcategoryAndRecommend
  // 1: SubcategoryAndRecommend
  // 3: OriginalNewVersion
  // 如果是二级页面，那就导入blog less
  if (parentCategoryID > 0) {
    // import('./styles/blog.less')
    import('./blog').then(res => {
      res.init();
    })
  }
  // if (!isOriginal) {
  //   if (pageStyle == 1) {
  //     import('./theme/CustomCategory.less')
  //   } else {
  //     import('./theme/CustomAndProductListCategory.less')
  //   }

  // } else {
  //   if (pageStyle == 3) {
  //     import('./theme/Subcategory2024.less')
  //   } else {
  //     import('./theme/category.less')
  //   }
  // }
})

ready(() => {
  on('.tabs-item', 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const tabItem = target.closest('.tabs-item')
    if (tabItem) {
      removeClass(tabItem.parentElement!.querySelectorAll('.tabs-item'), 'active');
      addClass(tabItem, 'active');
      const paneId = tabItem.getAttribute('data-paneid')!;
      const panel = document.querySelector<HTMLElement>('#' + paneId)!
      if (panel) {
        showElement(panel)
        hideElement(panel.parentElement!.querySelectorAll('.tab-pane:not(#' + paneId + ')'))
      }
    }
  });
})


const ddlIndustrychange = () => {
  const ddlIndustry = document.querySelector<HTMLSelectElement>("#ddlIndustry");
  if (ddlIndustry) {
    const selectedIndex = ddlIndustry.selectedIndex;
    const options = ddlIndustry.options[selectedIndex];
    document.querySelector<HTMLElement>('.r9-dropdown-status')!.innerHTML = options.text;
    if (ddlIndustry.value == '99') {
      showElement("#txtOthers")
    } else {

      hideElement("#txtOthers")
    }
    const txtOthers = document.querySelector<HTMLInputElement>("#txtOthers");
    if (txtOthers) {
      txtOthers.value = ''
      const errorEl = txtOthers.parentElement!.parentElement!.querySelector('.error-info');
      if (errorEl) {
        removeNode(errorEl)
      }
    }

  }
}



ready(() => {
  on('#txtEmail', 'click', (event: MouseEvent) => {
    const txtEmail = event.target as HTMLInputElement;
    if (txtEmail) {
      txtEmail.value = ''
    }
  })

  on('.sidebar-btn', 'click', () => {
    const txtEmail = document.querySelector<HTMLInputElement>('#txtEmail')!;
    const txtFname = document.querySelector<HTMLInputElement>('#txtFname')!;
    const txtLname = document.querySelector<HTMLInputElement>('#txtLname')!;
    const ddlIndustry = document.querySelector<HTMLInputElement>('#ddlIndustry')!;
    const txtOthers = document.querySelector<HTMLInputElement>('#txtOthers')!;

    ThirdPartySubscribeOptIn(txtEmail.value, "category", txtFname.value, txtLname.value, ddlIndustry.value, txtOthers.value);
  });

  const ddlIndustry = document.querySelector<HTMLSelectElement>("#ddlIndustry");
  if (ddlIndustry) {
    on(ddlIndustry, 'change', ddlIndustrychange)
  }
})

ready(() => {
  on(document, 'click', '.onsale_img a,.onsale_name a,.mask-layer', (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    const content = target.closest('.onsale-content')!;
    let pid = '';
    if (hasClass(content, 'slickdeals'))
      pid = content.getAttribute('id')!.replace('ProductGrid_', '');
    else
      pid = content.querySelector('.onsale_id')!.innerHTML.replace('#', '');

    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      "event": "select_item",
      "ecommerce": {
        "items": [
          {
            "item_id": pid,
            "item_name": content.querySelector('.onsale_name a')?.textContent,
            currency: "USD",
            "index": getIndex(content, document.querySelectorAll('.onsale-content')) + 1
          }
        ]
      }
    });
  });

})

ready(() => {
  on('.faq-item-title', 'click', (event: MouseEvent) => {
    const el = event.target as HTMLElement;
    toggleClass(el.parentElement!, 'collapse')

  })
})
//promotionPopup
ready(() => {
  import("@/share/promotionPopup").then(f => {
    f.loadPromotionPopup()
  })

})

ready(() => {
  if (document.querySelector('.copy-link')) {
    import("./copy-link")
  }
})

ready(() => {
  lazyLoad(".jcarousel-category .item-0 embed", (item) => {
    const src = item.getAttribute('src');
    if (!src) {
      item.setAttribute('src', (item.nextElementSibling as HTMLInputElement).value);
    }

  })
})
const setIframeSize = (pixels: any) => {
  $('#IframeSuperRush').height(pixels);
}
Object.assign(window, { setIframeSize })





